"use client";
import Image from "next/image";
import Header from "../Header";

const NosMarques = () => {
  
  const firstRowLogos = [
    "/NosMarques/Alfa.png",
    "/NosMarques/Aston.png",
    "/NosMarques/Audi.png",
    "/NosMarques/Bentley.png",
    "/NosMarques/BMW2.svg.png",
    "/NosMarques/Cadillac.png",
    "/NosMarques/Chery.png",
    "/NosMarques/Chevrolet.png",
    "/NosMarques/Chrysler.png",
    "/NosMarques/Citroen.png",
    "/NosMarques/Corvette.png",
    "/NosMarques/Daewoo.png",
    "/NosMarques/Dodge.png",
    "/NosMarques/Ferrari.png",
    "/NosMarques/Fiat.jpg",
    "/NosMarques/Ford.png",
    "/NosMarques/Geely.png",
    "/NosMarques/General-Motors.png",
    "/NosMarques/GMC.png",
    "/NosMarques/Haval.png",
    "/NosMarques/Honda.png",
    "/NosMarques/Hummer.png",
    "/NosMarques/Hyundai.png",
    "/NosMarques/Infiniti.png",
    "/NosMarques/Isuzu.png",
    "/NosMarques/Jaguar.png",
    "/NosMarques/Jeep.png",
  ];

  const secondRowLogos = [
    "/NosMarques/Kia.png",
    "/NosMarques/Lada.jpg",
    "/NosMarques/Lamborghini.png",
    "/NosMarques/Lancia.png",
    "/NosMarques/Land-Rover.png",
    "/NosMarques/Lexus.png",
    "/NosMarques/Maserati.png",
    "/NosMarques/Mazda.png",
    "/NosMarques/MG.png",
    "/NosMarques/Mini.png",
    "/NosMarques/Mitsubishi.png",
    "/NosMarques/Nissan.png",
    "/NosMarques/Opel.png",
    "/NosMarques/Peugeot.png",
    "/NosMarques/Porsche.png",
    "/NosMarques/Renault.png",
    "/NosMarques/Rolls.png",
    "/NosMarques/Rover.png",
    "/NosMarques/Saab.png",
    "/NosMarques/SEAT.png",
    "/NosMarques/Skoda.png",
    "/NosMarques/Smart.png",
    "/NosMarques/Subaru.png",
    "/NosMarques/Suzuki.png",
    "/NosMarques/Talbot.png",
    "/NosMarques/Tata.png",
    "/NosMarques/Tesla.png",
    "/NosMarques/Toyota.jpg",
    "/NosMarques/Vauxhall.png",
    "/NosMarques/Volkswagen.png",
    "/NosMarques/Volvo.png",
  ];
  
  return (
    <div className="w-full">
      {/* Title Section with Red Background */}
      <Header title={"Nos Marques"}/>

      {/* Logo Section with Neutral Background */}
      <div className="bg-white overflow-hidden py-6">
        {/* First Row (Left to Right) */}
        <div className="flex w-max animate-scroll-left gap-4">
          {[...firstRowLogos, ...firstRowLogos].map((el, index) => (
            <Image
              key={index}
              width={150}
              height={150}
              src={el}
              className="w-[100px] h-[100px] md:w-[200px] md:h-[200px] object-contain"
              alt="brand logo"
            />
          ))}
        </div>

        {/* Second Row (Right to Left) */}
        <div className="flex w-max animate-scroll-right gap-4 mt-4">
          {[...secondRowLogos,...secondRowLogos].map((el, index) => (
            <Image
              key={index}
              width={150}
              height={150}
              src={el}
              className="w-[100px] h-[100px] md:w-[200px] md:h-[200px] object-contain"
              alt="brand logo"
            />
          ))}
        </div>
      </div>

      {/* Button Section */}
      <div className="mx-auto w-[60%] md:w-fit pt-2 pb-12">
        
      </div>
    </div>
  );
};

export default NosMarques;
